import React from "react";
import { Link } from "react-router";
import Pagination from "../../components/Pagination";
import axios from "axios";
import classNames from "classnames";
import Filter from "../../components/Filter";

import { getDeep } from "../../functions.js";

export default class TrainersOverview extends React.Component {
    constructor(props) {
        super(props);

        let defaultFilters = {};
        defaultFilters["is_active"] = "1";

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0,
            activeFilters: defaultFilters
        };
    }

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0
        });
    };

    handleFilter = (name, value) => {
        let activeFilters = this.state.activeFilters;
        activeFilters[name] = value;

        this.setState({
            activeFilters,
            offset: 0
        });
        this.getResults(this.state.offset);
    };

    toggleItem = (e, itemID, itemName, currentStatus) => {
        let question = "Weet je zeker dat je deze opleider wilt activeren?";
        let description = `De opleider '${itemName}' is succesvol geactiveerd`;

        if (currentStatus) {
            // Current status is true, so we toggle to false
            question = "Weet je zeker dat je deze opleider wilt deactiveren?";
            description = `De opleider '${itemName}' is succesvol gedeactiveerd`;
        }

        if (confirm(question)) {
            axios
                .patch("/v1/trainers/" + itemID + "/", {
                    is_active: !currentStatus
                })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/trainers/edit/${itemID}`
                    });
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    getResults = (offset) => {
        this.cancelAxiosRequest();
        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        axios
            .get("/v1/trainers/", {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                },
                cancelToken: this.cancelSource.token
            })
            .then((response) => {
                this.setState({
                    resultRows: response.data.results,
                    count: response.data.count,
                    limit: response.data.limit,
                    offset: response.data.offset
                });

                // Check if there is only one result, if so, redirect
                const { permissions } = this.props;
                if (response.data.results.length === 1 && !getDeep(permissions, "company", "create")) {
                    let result = response.data.results[0];
                    this.props.router.push("/trainers/edit/" + result.uuid);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount() {
        this.getResults(0);
    }

    render() {
        let tableRows = [];
        const { permissions } = this.props;

        if (this.state.resultRows !== false) {
            let resultRows = this.state.resultRows;

            if (resultRows.length === 0) {
                tableRows.push(
                    <tr key="0">
                        <td colSpan="10">Met deze filters konden geen resultaten worden gevonden</td>
                    </tr>
                );
            }
            resultRows.forEach((result) => {
                let classnames = classNames({ inactive: !result.is_active });

                let activateItem = (
                    <i
                        className="fa fa-toggle-on"
                        title="Deactiveren"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.toggleItem(e, result.uuid, result.name, result.is_active);
                        }}
                    ></i>
                );
                if (!result.is_active) {
                    activateItem = (
                        <i
                            className="fa fa-toggle-off"
                            title="Activeren"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.toggleItem(e, result.uuid, result.name, result.is_active);
                            }}
                        ></i>
                    );
                }

                tableRows.push(
                    <tr
                        key={result.uuid}
                        onClick={() => {
                            this.props.router.push("/trainers/edit/" + result.uuid);
                        }}
                        className={classnames}
                    >
                        <td>{result.eol_relation_code ? result.eol_relation_code : "-"}</td>
                        <td>{result.name}</td>
                        {getDeep(permissions, "company", "change-trainer") ? <td>{activateItem}</td> : false}
                    </tr>
                );
            });
        } else {
            tableRows.push(
                <tr key="1">
                    <td colSpan="10">Opleiders ophalen...</td>
                </tr>
            );
        }

        return (
            <div>
                <div className="section-top">
                    <h1>Opleiders</h1>

                    <div className="section-buttons">
                        {getDeep(permissions, "company", "create") ? (
                            <Link to="/trainers/new" className="btn btn-primary">
                                Opleider toevoegen
                            </Link>
                        ) : (
                            false
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3 filters">
                        <Filter
                            title="Status"
                            type="list"
                            filterName="is_active"
                            filters={[
                                { value: "", name: "Alles" },
                                { value: "1", name: "Actief" },
                                { value: "0", name: "Inactief" }
                            ]}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                    </div>
                    <div className="col-9">
                        <div className="filter-text-wrapper">
                            <Filter
                                title="Zoeken"
                                type="text"
                                filterName="search"
                                filters={[]}
                                handleFilter={(name, value) => this.handleFilter(name, value)}
                                activeFilters={this.state.activeFilters}
                            />
                            <i className="fa fa-search" />
                        </div>

                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th>Relatienummer</th>
                                    <th>Opleider</th>
                                    {getDeep(permissions, "company", "change-trainer") ? <th>Actief</th> : null}
                                </tr>
                            </thead>
                            <tbody>{tableRows}</tbody>
                        </table>

                        <Pagination count={this.state.count} limit={this.state.limit} offset={this.state.offset} pageSwitch={(i) => this.getResults(i)} />
                    </div>
                </div>
            </div>
        );
    }
}
